import { render, staticRenderFns } from "./DashboardGeral.vue?vue&type=template&id=337f9602"
import script from "./DashboardGeral.vue?vue&type=script&lang=js"
export * from "./DashboardGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports